import { atom } from "jotai";

import {
  CurrentBookingWizardStepAtom,
  ListOfBookingWizardStepsAtom,
} from "../../stores";

export const getNextWizardStepAtom = atom((get) => {
  const currentStep = get(CurrentBookingWizardStepAtom);
  const steps = get(ListOfBookingWizardStepsAtom);
  const stepIndex = steps?.findIndex((step) => step === currentStep);

  if (stepIndex !== undefined && stepIndex < steps?.length - 1) {
    const nextStep = steps[stepIndex + 1];
    return nextStep;
  }
  return null;
});
